import React from 'react';

import { cssMap } from '@atlaskit/css';
import FolderClosedIcon from '@atlaskit/icon/core/folder-closed';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	container: {
		alignItems: 'center',
		backgroundColor: token('color.background.neutral'),
		borderRadius: token('radius.medium'),
		display: 'flex',
		height: '100%',
		justifyContent: 'center',
		width: '100%',
	},
});

export const LoomFolderIcon = (): React.JSX.Element => (
	<Box testId="loom-folder-icon" xcss={styles.container}>
		<FolderClosedIcon label="" color={token('color.icon')} size="small" spacing="none" />
	</Box>
);
